module.exports = __webpack_public_path__ + "img/first.20d8bc72.png";